<template>
    <div class="add-business-dialog">
        <el-dialog :visible="visible" title="工商信息" width="1230px" :close-on-click-modal='false'
            :close-on-press-escape='false' v-loading="addNewMainLoading" @close="handleClose">
            <div class="add-main-form-box">
                <dc-form ref='dcForm' :row="addNewMainData" :config="FIELDS" :col="2"
                    @data-changed="handleFormDataChange" labelWidth="150px">
                    <template v-slot:form-append="{ form, itemSetting, rIndex }">
                        <el-form-item :label="itemSetting.label" :prop="itemSetting.prop"
                            :label-width="itemSetting.labelWidth">
                            <span v-if="itemSetting.prop === 'isMicroEnt'">
                                {{ codesToNames(form[itemSetting.prop],
                                    dictData[itemSetting.optionsKey]) }}
                            </span>
                            <span v-else>
                                {{ form[itemSetting.prop] }}
                            </span>
                        </el-form-item>
                    </template>
                </dc-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import { fieldsConfig } from './config.js';
import { getRiskInfoWithTyc } from '@/modules/mdm/api/customer/customerManage.js';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc';
export default {
    components: { dcForm },
    props: {
        addNewMainLoading: {
            type: Boolean,
            default: false
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(fieldsConfig);
        const emit = setupContext.emit;

        const addNewMainData = ref({
            customerName: ''
        });
        const FIELDS = computed(() => {
            return config.fields;
        });

        // eslint-disable-next-line complexity
        const handleFormDataChange = ({ data, form, itemSetting }) => {
            addNewMainData.value = Object.assign(addNewMainData.value, form);
            // 获取商机列表函数
        };
        const confirm = () => {
            handleClose();
        };

        const dictData = ref({});
        const visible = ref(false);
        const show = async (val) => {
            visible.value = true;
            const res = await getDictDataApi({ dictCodes: 'SYS_YES_NO' });
            dictData.value = res.data;
            getBusinessInfo(val);
        };
        const handleClose = () => {
            visible.value = false;
        };
        const getBusinessInfo = (val) => {
            const params = {
                societyCreditCode: val.societyCreditCode,
                customerName: val.customerName
            };
            getRiskInfoWithTyc(params).then(res => {
                if (res && +res.code === 0) {
                    addNewMainData.value = {
                        ...res.data,
                        ebcuBusinessNo: res.data.ebcuBusinessNo || '-', // 营业执照号/注册号
                        ebcuOrgBarcode: res.data.ebcuOrgBarcode || '-', // 组织机构代码
                        ebcuLegalEntity: res.data.ebcuLegalEntity || '-', // 法人代表
                        ebcuAddress: res.data.ebcuAddress || '-', // 地址
                        tycAddress: res.data.ebcuAddress, // 注册地址
                        isMicroEnt: res.data.isMicroEnt?.toString()
                    };
                } else {
                    addNewMainData.value = {};
                }
            }).catch(() => {
                addNewMainData.value = {};
            });
        };
        return {
            emit,
            config,
            confirm,
            handleFormDataChange,
            addNewMainData,
            FIELDS,
            visible,
            dictData,
            show,
            handleClose,
            codesToNames: otherUtils.codesToNames
        };
    }
};
</script>
<style lang="less" scoped>
.add-business-dialog {
    .add-main-form-box {
        width: 100%;
        padding: 0 40px 0 0;
        box-sizing: border-box;
        height: 520px;
        overflow-y: auto;

        .el-select {
            width: 100%;
        }
    }

}
</style>
